<div class="container">
	<div class="row justify-content-center">
		<div class="col-12 col-lg-4">
      <div class="col-12 form-nav-bar position-absolute">
        <img src="assets/images/go-back-arrow.svg" class="icon d-block d-lg-none" [routerLink]="['/login']" alt="go-back-arrow">
      </div>
			<!-- Remember password form -->
			<form [formGroup]="remember_form">

        <div class="logo d-flex justify-content-center">
          <img src="assets/images/logo-light.svg" alt="logo-atalaya-light">
        </div>

        <h3 *ngIf="url_token == null">{{ 'REMEMBER_PASSWORD.rememberPassword' | translate }}</h3>
        <h3 *ngIf="url_token != null">{{ 'REMEMBER_PASSWORD.newPassword' | translate }}</h3>
				<div class="form-group" *ngIf="!reset_password && url_token == null">
          <onwac-input 
						[type]="'email'" 
						[label]="'FORMS.fields.email' | translate"
            [input_name]="'username'"
            [help_text]="'REMEMBER_PASSWORD.email.helpText' | translate"
						[submitted]="submitted"
            [parentForm]="remember_form"
            [validators_feedback]="[
							{name : 'required', value : 'FORMS.validators.required' | translate },
							{name : 'email', value : 'FORMS.validators.email' | translate }
						]"></onwac-input>
				</div>
        
        <div class="form-group" *ngIf="reset_password">
          <h4>{{ 'REMEMBER_PASSWORD.perfect' | translate }}</h4>
          <p>{{ 'REMEMBER_PASSWORD.successRememberPassText' | translate }}</p>
        </div>


        <div class="form-group" *ngIf="url_token != null && !new_password">
          <onwac-input 
          [type]="'password'" 
          [label]="'FORMS.fields.password' | translate"
          [input_name]="'password'"
          [submitted]="submitted"
          [parentForm]="remember_form"
          (keyup)="checkValidPassword($event.target.value)"
          ></onwac-input>
          <div class="item-list">
            <div class="item-check" [ngClass]="{warning: !lengthFlag}"><p>{{ 'REMEMBER_PASSWORD.moreThanXchars' | translate }}</p></div>
            <div class="item-check" [ngClass]="{warning: !capitalFlag}"><p>{{ 'REMEMBER_PASSWORD.atLeastOneUppercase' | translate }}</p></div>
            <div class="item-check" [ngClass]="{warning: !numberFlag}"><p>{{ 'REMEMBER_PASSWORD.atLeastOneNumber' | translate }}</p></div>
          </div>

					
        </div>


        <div class="form-group" *ngIf="url_token != null && new_password">
          <h4>{{ 'REMEMBER_PASSWORD.successChangedPassword' | translate }}</h4>
          <p> {{ 'REMEMBER_PASSWORD.successChangedPasswordText' | translate }} </p>
        </div>



				<div class="form-group submit">
					<onwac-button *ngIf="!reset_password && url_token == null" [text]="'REMEMBER_PASSWORD.send' | translate" [size]="'large'" [extra_clases]="'block'" class="w-100" (click)="onSubmit()"></onwac-button>
					<onwac-button *ngIf="reset_password || new_password" [text]="'REMEMBER_PASSWORD.backToLogin' | translate" [type]="'bordered'" [size]="'large'" [extra_clases]="'block'" class="w-100" [routerLink]="['/login']"></onwac-button>
					<onwac-button *ngIf="url_token != null && !new_password" [text]="'REMEMBER_PASSWORD.update' | translate" [size]="'large'" [extra_clases]="'block'" [disabled]="!valid_password" class="w-100" (click)="changePassword()"></onwac-button>
        </div>
        
        <p class="small text-center d-none d-lg-block" *ngIf="!reset_password && !new_password">
          <a [routerLink]="['/login']">{{'REMEMBER_PASSWORD.backToLogin' | translate}}</a>
        </p>
			
			</form>
			<!-- End remember password form -->

		</div>
	</div>
</div>

<onwac-snackbar 
[status_class]="snackbar.status_class"
[text]="snackbar.text"
[activate]="snackbar.active"
(hidden)="snackbar.deactivate()"
></onwac-snackbar>